<app-page-panel pageTitle="Projekte" [showBackButton]="false" iconNameIonicon="filing"
  [customButton1Title]="this.userService.userInfo()!.allowProjektantrag ? 'Projektanlage' : ''"
  [showDetailsButton]="false" [showSidepanelButton]="false" [showBackColor]="true"
  (customButton1Clicked)="onProjektAntragButtonClick()"
  [customButton2Title]="this.userService.userInfo()!.allowWirtschaftsplan ? 'Wirtschaftsplan' : ''"
  (customButton2Clicked)="onWirtschaftsplanButtonClick()">

  <dx-data-grid #dataGridProjekte fxFill [allowColumnResizing]="true" [rowAlternationEnabled]="true"
    [allowColumnReordering]="true" [hoverStateEnabled]="true" noDataText="" [dataSource]="projekte()"
    (onRowDblClick)="onDataGridRowDblClick($event)" (onContentReady)="onContentReady($event)"
    (onInitialized)="onGridInitialized($event)" [height]="'calc(100vh - 146px)'"
		(onExporting)="onGridExporting($event)">
     <dxo-export [enabled]="true"></dxo-export>
  	<dxi-column dataField="projektID" caption="ProjektID" [width]="80" [visible]="false" alignment="left"></dxi-column>
    <dxi-column dataField="budgetantragID" caption="BaID" [width]="80" [visible]="false" alignment="left"></dxi-column>
    <dxi-column dataField="name" caption="Projekt" alignment="left" minWidth="200"></dxi-column>
    <dxi-column dataField="controllingbereich" caption="Controllingbereich" [visible]="true"
      alignment="left"></dxi-column>
    <dxi-column dataField="plangebiet" caption="Plangebiet" [visible]="true" alignment="left"
      groupCellTemplate="groupCellTemplateTOPunkt"></dxi-column>
    <dxi-column dataField="quartier" caption="Quartier" alignment="left"></dxi-column>
    <dxi-column dataField="klassifizierung" caption="Klassifizierung" [width]="150" alignment="left"
      [visible]="appStateService.isBauControlling()"></dxi-column>
    <dxi-column dataField="kostenstelle" caption="Kostenstelle" [width]="150" alignment="left"
      [visible]="!appStateService.isBauControlling()"></dxi-column>
    <dxi-column dataField="kostengruppe" caption="Kostengruppe" [width]="150" alignment="left"
      [visible]="!appStateService.isBauControlling()"></dxi-column>
    <dxi-column dataField="filtergruppe" caption="Filtergruppe" [width]="150" alignment="left"></dxi-column>
    <dxi-column dataField="aktiv" caption="Aktiv" [width]="75" alignment="left" trueText="Ja"
      falseText="Nein"></dxi-column>
    <dxi-column dataField="pm" caption="PM" [width]="75" alignment="left"></dxi-column>
    <dxi-column dataField="pst" caption="PST" [width]="150" alignment="left"></dxi-column>
    <dxi-column dataField="letzterBudgetantragAm" caption="Letzter BA" [width]="100" alignment="left" dataType="date"
      format="dd.MM.yyyy"></dxi-column>
    <dxi-column dataField="letzterBudgetplanAm" caption="Letzter BP" [width]="100" alignment="left" dataType="date"
      format="dd.MM.yyyy"></dxi-column>
   <dxi-column #dataCellStatus dataField="status" caption="Status" [width]="150" alignment="left"
      cellTemplate="statusCellTemplate">
      <div *dxTemplate="let data of 'statusCellTemplate'">
        <ng-container [ngSwitch]="data.value">
          <span class="dx-cell-padding">{{data.value}}</span>
          <span *ngSwitchCase="'Gestellt'" class="material-symbols-outlined icon-round-24px backcolor-success"
            title="Der Antrag wurde gestellt.">schedule</span>
          <span *ngSwitchCase="'Empfohlen'" class="material-symbols-outlined icon-round-24px backcolor-accent"
            title="Das Gesamtbudget ist zu mehr als 80% ausgeschöpft.">info</span>
          <span *ngSwitchCase="'Nötig'" class="material-symbols-outlined icon-round-24px noetig"
            title="Das aktuelle Jahresbudget ist zu mehr als 80% ausgeschöpft.">info</span>
          <span *ngSwitchCase="'Dringend'" class="material-symbols-outlined icon-round-24px backcolor-warn"
            title="Das Jahresbudget oder Gesamtbudget wurde überschritten.">info</span>
        </ng-container>
      </div>
    </dxi-column>
    <dxi-column dataField="aktuelleBearbeitung" caption="Bearbeitung" [width]="150" alignment="left"></dxi-column>
    <dxi-column type="buttons" caption="" [width]="80">
      <dxi-button hint="Projektdetails" icon="more" [onClick]="onProjektButtonClick.bind(this)">
      </dxi-button>
      <dxi-button hint="Aktueller Budgetantrag" icon="arrowright" [visible]="true" [disabled]="isBudgetantragAvailable"
        [onClick]="onBudgetantragButtonClick.bind(this)">
      </dxi-button>
      <!-- <dxi-button template="projektButton" [onClick]="this.onProjektButtonClick.bind(this)">
            <div *dxTemplate="let data of 'projektButton'">
              <span color="primary" class="ion-md-filing icon-24px-contrast"></span>
            </div>
          </dxi-button>
          <dxi-button [visible]="isDeleteVisible" template="budgetantragButton" [onClick]="onBudgetantragButtonClick.bind(this)">
            <div *dxTemplate="let data of 'budgetantragButton'">
                <span color="primary" class="material-symbols-outlined icon-24px-contrast">wallet</span>
            </div>
          </dxi-button> -->
    </dxi-column>
    <dxo-toolbar>
      <dxi-item location="before">
        <div *dxTemplate class="info-box">
          <i class="dx-icon-formula dx-icon-info-box"></i>
          {{dataCountText()}}
        </div>
      </dxi-item>
      @if(infoText()){
      <dxi-item location="before">
        <div *dxTemplate class="info-box">
          <i class="dx-icon-filter dx-icon-info-box"></i>
          {{infoText()}}
        </div>
      </dxi-item>
      }

      <dxi-item location="after">
        <div *dxTemplate>
          <dx-button icon="refresh" matTooltip="Grid zurücksetzen"
            (onClick)="gridService.resetGridState(dataGrid, appStateService.gridStateProjekte)">
          </dx-button>
        </div>
      </dxi-item>
      <dxi-item location="after">
        <div *dxTemplate>
          <dx-button icon="clear" matTooltip="Filter zurücksetzen" (onClick)="onHeaderFilterButtonClick()">
          </dx-button>
        </div>
      </dxi-item>
      <dxi-item location="after">
        <div *dxTemplate>
          <dx-button icon="search" matTooltip="Filterzeile anzeigen" (onClick)="onFilterRowButtonClick()">
          </dx-button>
        </div>
      </dxi-item>
      <dxi-item name="columnChooserButton" matTooltip="Spalten auswählen"></dxi-item>
      <dxi-item name="searchPanel"></dxi-item>
	  <dxi-item name="exportButton"></dxi-item>
    </dxo-toolbar>
    <dxo-group-panel [visible]="true" emptyPanelText=""></dxo-group-panel>
    <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
    <dxo-search-panel [visible]="true" [width]="250" placeholder="Ergebnisliste filtern"></dxo-search-panel>
    <dxo-header-filter [visible]="showHeaderFilter()" search.enabled="true"></dxo-header-filter>
    <dxo-filter-row [visible]="showFilterRow()"></dxo-filter-row>
    <dxo-scrolling mode="virtual" useNative="true"></dxo-scrolling>
    <dxo-grouping [contextMenuEnabled]="true" [autoExpandAll]="true"></dxo-grouping>
    <dxo-selection mode="single"></dxo-selection>
    <dxo-load-panel [enabled]="true" [showPane]="false"></dxo-load-panel>
    <dxo-pager [visible]="true" displayMode="full" [showNavigationButtons]="true"
      [showPageSizeSelector]="true"></dxo-pager>
  </dx-data-grid>

</app-page-panel>